import { render, staticRenderFns } from "./ProductItemSelector.vue?vue&type=template&id=12467542&scoped=true&"
import script from "./ProductItemSelector.vue?vue&type=script&lang=js&"
export * from "./ProductItemSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemSelector.vue?vue&type=style&index=0&id=12467542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12467542",
  null
  
)

export default component.exports